<mat-dialog-content data-testid="registration-complete-dialog">
  <h2>Your Free account is ready</h2>
  <p>Finish your session by adding a <strong>short reflection</strong> about how things feel right now.</p>
  <p><strong>Save Session</strong> to keep this first snapshot.</p>
  <p>Visit your <strong>Dashboard</strong> anytime to see your trends and changes.</p>
  <p>We’re glad you’re here.</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <wil-cta-button
    [disabled]="false"
    [loading]="false"
    ctaText="Close"
    (ctaClick)="close()"
    [style]="'primary'"
    [size]="'large'"
    data-testid="registration-complete-dialog-close-button"
  ></wil-cta-button>
</mat-dialog-actions>
